import { Variable, VariableSummary } from '@mtna/pojo-consumer-ui';

import { RdsTextFilter } from '../../../text-filter/text-filter.model';
import { BaseFilter } from './base-filter.model';
import { RdsNullFilter } from './null-filter.model';

export class FilterByText<V extends Variable | VariableSummary> extends BaseFilter<V> {
  constructor(variable: V, public textFilters: Array<RdsTextFilter>, nullFilter?: RdsNullFilter) {
    super(variable, nullFilter);
  }
}

export function instanceOfFilterByText(obj: any): obj is FilterByText<Variable | VariableSummary> {
  return !!obj && 'variable' in obj && 'textFilters' in obj;
}
